<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.educational') }}</h5>
    </template>

    <b-row>
      <b-col md="6">
        <o-form-group :label="practiceLabel">
          <b-form-input v-model="item.no_of_medical_practices"
                        type="number"
                        :readonly="readonly"
                        :state="practiceCountValid"/>
          <b-form-invalid-feedback v-if="practiceCountValid === false">
            {{ $t('sandoz.min_3_doctors') }}
          </b-form-invalid-feedback>
        </o-form-group>

        <o-form-group :label="$t('sandoz.total_training_budget')">
          <b-form-input v-model="item.total_training_budget"
                        type="number" step="0.01"
                        :readonly="readonly || !isDraft"/>
        </o-form-group>

        <o-form-group :label="maxThresholdLabel">
          <b-form-input v-model="item.max_threshold_per_hcp"
                        type="number" step="0.01" :max="3000"
                        :readonly="readonly"
                        :state="thresholdValid"/>
          <small class="form-text text-muted">{{ maxThresholdHelp }}</small>
          <b-form-invalid-feedback v-if="thresholdValid === false">
            {{ $t('sandoz.max_threshold_cap_3000') }}
          </b-form-invalid-feedback>
        </o-form-group>
      </b-col>

      <b-col md="6">
        <o-form-group :label="$t('sandoz.planned_amount_of_educational')">
          <b-form-input v-model="item.planned_amount_of_educational"
                        type="number" step="0.01"
                        :readonly="readonly"
                        :state="budgetValid"/>
          <b-form-invalid-feedback v-if="budgetValid === false">
            {{ $t('sandoz.budget_below_60_percent') }}
          </b-form-invalid-feedback>
        </o-form-group>

        <o-form-group :label="$t('sandoz.amount_of_educational')">
          <b-form-input :value="item.amount_of_educational" :readonly="true"/>
        </o-form-group>

        <o-form-group v-if="!isDraft" :label="$t('sandoz.actual_amount_of_educational')">
          <b-input-group>
            <b-form-input v-model="item.actual_amount_of_educational" type="number" step="0.01"/>
          </b-input-group>
          <small v-if="item.revUserName" class="form-text text-muted">
            {{ $t('sandoz.last_updated_by') }}: {{ item.revUserName }}
          </small>
        </o-form-group>
      </b-col>
    </b-row>

    <o-checkbox v-if="item.plan_deviation_skip_approval !== undefined"
                :label="$t('sandoz.plan_deviation_skip_approval')"
                v-model="item.plan_deviation_skip_approval"/>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * Training budget, course participants, HCP thresholds. Source: educational/ContractDetail.vue.
 *
 * Validation matches the source: minimum 3 medical practices, 3000 cap on per-HCP threshold,
 * planned amount must be at least 60% of total training budget. Label wording varies by type
 * (pharmacists for APO_EDU/KAM_APO_EDU, doctors elsewhere).
 */
export default {
  name: 'SectionEducational',
  mixins: [sectionMixin],
  computed: {
    isApoEdu() {
      const t = this.item.type || ''
      return t === 'APO_EDU' || t === 'KAM_APO_EDU'
    },
    isDraft() {
      return (this.item.status || 'Draft') === 'Draft'
    },
    practiceLabel() {
      return this.isApoEdu
        ? this.$t('sandoz.no_of_pharmacists')
        : this.$t('sandoz.no_of_doctors')
    },
    maxThresholdLabel() {
      return this.isApoEdu
        ? this.$t('sandoz.max_threshold_per_pharmacist')
        : this.$t('sandoz.max_threshold_per_doctor')
    },
    maxThresholdHelp() {
      return this.$t('sandoz.max_threshold_help')
    },
    practiceCountValid() {
      const n = Number(this.item.no_of_medical_practices)
      if (!this.item.no_of_medical_practices) {
        return null
      }
      return n >= 3 ? null : false
    },
    thresholdValid() {
      const v = Number(this.item.max_threshold_per_hcp)
      if (!this.item.max_threshold_per_hcp) {
        return null
      }
      return v <= 3000 ? null : false
    },
    budgetValid() {
      const planned = Number(this.item.planned_amount_of_educational)
      const total = Number(this.item.total_training_budget)
      if (!planned || !total) {
        return null
      }
      return planned >= total * 0.6 ? null : false
    }
  }
}
</script>
